<template>
<div>
    <el-drawer
        title="登记处理"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        append-to-body
        size="500px"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <el-form :model="formData" ref="formData" label-position="top" size="medium">                
                <el-form-item prop="remark" label="处理备注:">
                    <el-input v-model="formData.remark" placeholder="请填写处理备注" :minlength="400" type="textarea" maxlength="100" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">            
            <el-button @click="close()">关闭</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确定</el-button>
        </div>
    </el-drawer>
   
</div>
</template>
<script>
const defaultFormData = {
    remark:'',
    orderSns:''
}
export default {
    
    data(){
        return{
            drawerShow: false,
            dataLoading: false, 
			btnLoading:false,
			formData: {
			    ...defaultFormData
			},
			
        }
    },
    computed:{
        
       
    },
    methods:{
        close(){ 
			this.formData = {...defaultFormData};
			this.$refs.formData.resetFields();
            this.drawerShow = false;		  
        },
        show(orderSn,type){
			if( type == 1 ){
				this.formData.orderSns = orderSn
			}else{
				this.formData.orderSns = [orderSn]		
			}
			
            this.drawerShow = true;
			
        },        
		submitForm(){
			this.$refs['formData'].validate((valid) => {
			    if (valid) {
			        this.btnLoading = true;
			              
			        this.$request({
			            url:'/finance/refund/diff/deal',
			            method: "POST",
			            data: {...this.formData},
			        }).then(res=>{
			            const {state, msg} = res.data;
			            if (state == 1) {
			                this.$message.success('操作成功');
							this.$emit('onUpdate');
			                this.close();
			            } else {
			                this.$message.error(msg || "请求失败");
			            }
			        }).catch(() => {
			            this.$message.error("请求错误");
			        }).finally(()=>{
			            this.btnLoading = false;
			        })
			    }
			});
		},
		
		
		
    }
}
</script>

<style lang="scss" scoped>
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>